import { render } from "./widget-tariffs-skeleton.vue?vue&type=template&id=7971c0dc&scoped=true"
import script from "./widget-tariffs-skeleton.vue?vue&type=script&lang=js"
export * from "./widget-tariffs-skeleton.vue?vue&type=script&lang=js"

import "./widget-tariffs-skeleton.vue?vue&type=style&index=0&id=7971c0dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7971c0dc"]])

export default __exports__